
import { Vue } from "vue-class-component";

export default class BillAdd extends Vue {}
